import React from 'react';
import { Result, Button } from 'antd';
import { Link } from 'react-router-dom';

const email = process.env.REACT_APP_PMS_ADMIN_EMAIL;
const subject = 'User is disabled in PMS';

const handleOnClick = (e) => {
  window.location.href = `mailto:${email}?subject=${subject}`;
  e.preventDefault();
};

const UserNotFound = () => {
  return (
    <Result
      className="standalone-result-page"
      status="warning"
      title="User Disabled"
      subTitle={
        <p>
          Sorry, your account is disabled in PMS. <br />
          Please contact PMS administrator.
        </p>
      }
      extra={[
        <Link to="#" onClick={handleOnClick}>
          <Button type="primary">Contact PMS administrator</Button>
        </Link>,
        <Button>
          <Link to="/login">Go back to Login</Link>
        </Button>,
      ]}
    />
  );
};

export default UserNotFound;
